export default {
  smtp: []
}
